module.exports = "/images/visa.svg?db196b1fce0acf8e50ad73c9b03c54c1";